import { AgColumnDefinition, AgGridColumnType, AgGridExportType } from '@/shared/models/ag-grid.model'
import i18n from '@/lang/i18n'

export const billingGridCasesDetailColumnDefs =
    (): Array<AgColumnDefinition> => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            headerName: i18n.tc('accounting.field.elementID'),
            field: 'entityLabel',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 100,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.conceptCode'),
            field: 'concept.code',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.concept'),
            field: 'concept.name',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.conceptGroup'),
            field: 'concept.group.name',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.alias'),
            field: 'alias',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 150,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.reference'),
            field: 'referenceCode',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.client'),
            field: 'customer.name',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.rate'),
            field: 'rate.name',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.value'),
            field: 'value',
            type: AgGridColumnType.DECIMAL,
            exportType: AgGridExportType.DOUBLE,
            minWidth: 100,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.unit'),
            field: 'unit.symbol',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 100,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.authorizationRequired'),
            field: 'requiresAuthorization',
            type: AgGridColumnType.CHECK_ICON,
            exportType: AgGridExportType.BOOLEAN,
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.authorization'),
            field: 'authorizationCode',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.authorizationRequested'),
            field: 'authorizationRequested',
            type: AgGridColumnType.CHECK_ICON,
            exportType: AgGridExportType.BOOLEAN,
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.error'),
            field: 'autoInvoiceSystemInError',
            type: AgGridColumnType.CHECK_ICON,
            exportType: AgGridExportType.BOOLEAN,
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.errorDescription'),
            field: 'autoInvoiceSystemErrorDescription',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 120,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.notToInvoice'),
            field: 'addToInvoice',
            type: AgGridColumnType.CHECK_ICON,
            exportType: AgGridExportType.BOOLEAN,
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('billing.label.reasonIfNotToAddToInvoice'),
            field: 'reasonIfNotToAddToInvoice',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 150,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.automatic'),
            field: 'automatic',
            type: AgGridColumnType.CHECK_ICON,
            exportType: AgGridExportType.BOOLEAN,
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.assignmentDate'),
            field: 'creationDate',
            type: AgGridColumnType.DATETIME,
            exportType: AgGridExportType.DATETIME,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.user'),
            colId: 'creationUser.normalizedFullName',
            field: 'creationUser.fullName',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.deliveryNote'),
            field: 'deliveryNote.label',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 100,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.isCopayment'),
            field: 'isCopayment',
            type: AgGridColumnType.CHECK_ICON,
            exportType: AgGridExportType.BOOLEAN,
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.hasCopayment'),
            field: 'hasCopayments',
            type: AgGridColumnType.CHECK_ICON,
            exportType: AgGridExportType.BOOLEAN,
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.copaymentType'),
            field: 'copaymentType',
            type: AgGridColumnType.BILLING_COPAYMENT_TYPE,
            exportField: 'copaymentType.translatedName',
            exportType: AgGridExportType.TEXT,
            minWidth: 80,
            suppressSizeToFit: true
        }
    ]
